import { useEffect, useState, useRef } from "react";

import InputGroup from 'react-bootstrap/InputGroup'
import Button from "react-bootstrap/Button"
import ToggleButton from 'react-bootstrap/ToggleButton';
import ButtonGroup from "react-bootstrap/ButtonGroup"
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import Form from 'react-bootstrap/Form'
import Table from 'react-bootstrap/Table'
import Modal from 'react-bootstrap/Modal'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import { MdRemoveCircle } from "react-icons/md";

import Container from 'react-bootstrap/Container'
import { Helmet } from 'react-helmet'

import 'bootstrap/dist/css/bootstrap.min.css';



import { backendAccessGet, backendAccessPost } from "../Utils/Authentication";

const priority = [
    { name : 'Priority 1', idx: 0 },
    { name : 'Priority 2', idx: 1 },
    { name : 'Priority 3', idx: 2 }
]

export function RoleForm( props )
{
    const name = props.name 
    const setName = props.setName 
    const nameError = props.nameError

    const departments = props.departments 
    const department = props.department 
    const setDepartment = props.setDepartment 

    const minCap = props.minCap 
    const setMinCap = props.setMinCap 
    const maxCap = props.maxCap
    const setMaxCap = props.setMaxCap

    const specialization = props.specialization 
    const setSpecialization = props.setSpecialization

    const schedule = props.schedule 
    const setSechdule = props.setSechdule

    const handleChange = (val) => {
        setSechdule(val);
    };

    return (
        <>
            <div style={{ marginBottom:'5px'}}>
                <div>
                    <b>Name</b>
                </div>
                <div>
                    <Form.Control value={name} 
                                  onChange={ e => setName( e.target.value )}
                                  isInvalid={nameError}
                    />
                </div>
                <div>
                    <b>Department</b>
                </div>
                { departments &&
                <div>
                    <Form.Select value={department} onChange={ e => setDepartment(e.target.value)}>
                        <option disabled selected hidden value="">-- Select department --</option>
                        { departments.map( (d,idx) => 
                        <option key={idx} value={d.uid}>{d.name}</option>
                        )}
                    </Form.Select>
                </div>
                }
                <div>
                    <b>Daily Min Capacity</b>
                </div>
                <div>
                    <Form.Control value={minCap} 
                                  onChange={ e => setMinCap( e.target.value )}
                    />
                </div>
                <div>
                    <b>Daily Max Capacity</b>
                </div>
                <div>
                    <Form.Control value={maxCap} 
                                  onChange={ e => setMaxCap( e.target.value )}
                    />
                </div>
                <div>
                    <b>Specialization required?</b>
                </div> 
                <div>
                    <Form.Select value={specialization} onChange={ e => setSpecialization(e.target.value)}>
                        <option key="0" value="0">No</option>
                        <option key="1" value="1">Yes</option> 
                    </Form.Select>
                </div>
                <div>
                    <b>Schedule</b>
                </div>
                <div className="d-flex justify-content-center">
                    Morning
                </div>
                <div className="d-flex justify-content-center" >
                    <ToggleButtonGroup type="checkbox" value={schedule} onChange={handleChange}>
                        <ToggleButton id="tbg-btn-1" value="00-mon-morning">Mon</ToggleButton>
                        <ToggleButton id="tbg-btn-2" value="10-tue-morning">Tue</ToggleButton>
                        <ToggleButton id="tbg-btn-3" value="20-wed-morning">Wed</ToggleButton>
                        <ToggleButton id="tbg-btn-4" value="30-thu-morning">Thu</ToggleButton>
                        <ToggleButton id="tbg-btn-5" value="40-fri-morning">Fri</ToggleButton>
                    </ToggleButtonGroup>
                </div>
                <div className="d-flex justify-content-center">
                    Afternoon
                </div>
                <div className="d-flex justify-content-center" >
                    <ToggleButtonGroup type="checkbox" value={schedule} onChange={handleChange}>
                        <ToggleButton id="tbg-btn-6" value="01-mon-afternoon">Mon</ToggleButton>
                        <ToggleButton id="tbg-btn-7" value="11-tue-afternoon">Tue</ToggleButton>
                        <ToggleButton id="tbg-btn-9" value="21-wed-afternoon">Wed</ToggleButton>
                        <ToggleButton id="tbg-btn-10" value="31-thu-afternoon">Thu</ToggleButton>
                        <ToggleButton id="tbg-btn-11" value="41-fri-afternoon">Fri</ToggleButton>
                    </ToggleButtonGroup>
                </div>

            </div>
        </>
    )
}

export function AddRoleModal( props )
{
    const showModal = props.showModal 
    const setShowModal = props.setShowModal
    const setRoles = props.setRoles
    const departments = props.departments

    const [ name, setName ] = useState("")
    const [ nameError, setNameError ] = useState(false)
    const [ department, setDepartment ] = useState("")
    const [ minCap, setMinCap ] = useState("")
    const [ maxCap, setMaxCap ] = useState("")
    const [ specialization, setSpecialization ] = useState("0")
    const [ schedule, setSechdule ] = useState([]) 

    useEffect( () => {
        if(showModal)
        {
            setName("")
            setNameError(false)
            setDepartment("")
            setMinCap("")
            setMaxCap("")
            setSpecialization("0")
            setSechdule([])
        }
    },[showModal])
   
    const addRole = () => {
        setNameError(false)
        if( name == "" )
        {
            setNameError(true)
        }

        var dd = {}
        dd['name'] = name 

        var data = {}
        data['department'] = department 
        data['min_cap'] = minCap 
        data['max_cap'] = maxCap
        data['specialization'] = specialization
        data['schedule'] = schedule

        dd['data'] = data

        backendAccessPost('/api/roles/add/', dd).then( res => {
            if( 'error_message' in res )
            {
                alert( res.error_message )
                return
            }

            setRoles( res.roles )
            setShowModal(false)
        })
    }

    return (
        <Modal show={showModal} onHide={e => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Add Role</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <RoleForm name={name}
                          setName={setName}
                          nameError={nameError}
                          departments={departments}
                          department={department}
                          setDepartment={setDepartment}
                          minCap={minCap}
                          setMinCap={setMinCap}
                          maxCap={maxCap}
                          setMaxCap={setMaxCap}
                          specialization={specialization}
                          setSpecialization={setSpecialization}
                          schedule={schedule}
                          setSechdule={setSechdule}
                />
            </Modal.Body>
            <Modal.Footer>
                    <Button variant="outline-primary" onClick={e => setShowModal(false)} size="sm">Close</Button>
                    <Button variant="outline-primary" onClick={addRole} size="sm">Add</Button>
            </Modal.Footer>
        </Modal>
    )
}

export function EditRoleModal( props )
{
    const showModal = props.showModal 
    const setShowModal = props.setShowModal

    const roleUid = props.roleUid
    
    const roles = props.roles
    const setRoles = props.setRoles
    const departments = props.departments
    //const setRoles = props.setRoles

    //const departments = props.departments
    //const closeModal = props.closeModal

    //const staff = props.staff

    const [ name, setName ] = useState("")
    const [ nameError, setNameError ] = useState(false)
    const [ department, setDepartment ] = useState("")
    const [ minCap, setMinCap ] = useState("")
    const [ maxCap, setMaxCap ] = useState("")
    const [ specialization, setSpecialization ] = useState("0")
    const [ schedule, setSechdule ] = useState([]) 

    const reload = () => {
        if( roleUid.current == null )
        {
            return
        }
        
        let role = null

        for( let r of roles )
        {
            if( r.uid == roleUid.current )
            {
                role = r
            }
        }

        setName( role.name )

        if( role.data.department )
        {
            setDepartment(role.data.department)
        }
        else 
        {
            setDepartment("")
        }

        if( role.data.min_cap )
        {
            setMinCap(role.data.min_cap)
        }
        else 
        {
            setMinCap("")
        }

        if( role.data.max_cap )
        {
            setMaxCap(role.data.max_cap)
        }
        else
        {
            setMaxCap("")
        }

        if( role.data.specialization )
        {
            setSpecialization( role.data.specialization )
        }
        else 
        {
            setSpecialization("0")
        }

        if( role.data.schedule )
        {
            setSechdule( role.data.schedule )
        }
        else 
        {
            setSechdule([])
        }
    }

    useEffect( () => {
        if( !showModal )
        {
            return
        }

        reload() 
    }, [showModal])
    
    const updateRole = () => {
        var dd = {}
        dd['role_uid'] = roleUid.current
        dd['name'] = name 

        var data = {}
        data['department'] = department 
        data['min_cap'] = minCap 
        data['max_cap'] = maxCap 
        data['specialization'] = specialization
        data['schedule'] = schedule

        dd['data'] = data
 
        backendAccessPost('/api/roles/update/', dd).then( res => {
            if( 'error_message' in res )
            {
                alert( res.error_message )
                return
            }

            setRoles( res.roles )
            setShowModal(false)
        })
    }
    
    const removeRole = () => {
        /*var data = {}
        data['position_uid'] = positionPid
 
        backendAccessPost('/api/planner/daily/positions/remove/', data).then( res => {
            if( 'error_message' in res )
            {
                alert( res.error_message )
                return
            }

            setPositions( res.positions )
            closeModal()
        })*/
    }

    return (
        <Modal show={showModal} onHide={e => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Edit role ({roleUid.current})</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <RoleForm name={name}
                          setName={setName}
                          nameError={nameError}
                          departments={departments}
                          department={department}
                          setDepartment={setDepartment}
                          minCap={minCap}
                          setMinCap={setMinCap}
                          maxCap={maxCap}
                          setMaxCap={setMaxCap}
                          specialization={specialization}
                          setSpecialization={setSpecialization}
                          schedule={schedule}
                          setSechdule={setSechdule}
                />
            </Modal.Body>
            <Modal.Footer>
                    <Button size="sm" onClick={e => setShowModal(false)}>
                        Close
                    </Button>
                    <Button size="sm" onClick={updateRole}>
                        Update
                    </Button>
            </Modal.Footer>
        </Modal>
    )
}

export function RoleRow( props )
{
    const index = props.index 
    const info = props.info 

    const removeFn = props.removeFn
    const editFn = props.editFn

    return (
        <tr>
            <td>{ index+1 }</td>
            <td>{ info.name }</td>
            <td>{ info.uid }</td>
            <td>
                <ButtonGroup>
                    <Button variant="outline-primary" onClick={ e => editFn(info.uid) } size="sm">Edit</Button>
                    <Button variant="outline-danger" onClick={ e => removeFn(info.uid) } size="sm">Remove</Button>
                </ButtonGroup>
            </td>
        </tr>

    )
}

export default function Roles( props )
{
    const [ roles, setRoles ] = useState([])
    const [ departments, setDepartments ] = useState([])

    const [ showAddRole, setShowAddRole ] = useState( false )
    const [ showEditRole, setShowEditRole ] = useState( false )
    const editRoleUid = useRef(null)

    useEffect( () => {
        backendAccessGet('/api/roles/fetch/').then( res => {
            if( res.error_message )
            {
                alert( res.error_message )
                return
            }

            setRoles( res.roles )
            setDepartments( res.departments )
        })


    },[])

    const openAddRoleModal = () => {
        setShowAddRole( true )
    }

    const closeAddRoleModal = () => {
        setShowAddRole( false )
    }

    const removeRole = ( uid ) => {
        if( !window.confirm("Are you sure you want to remove the role?") )
        {
            return
        }

        let data = {}
        data.uid = uid

        backendAccessPost('/api/roles/remove/', data).then( res => {
            if( res.error_message )
            {
                alert( res.error_message )
                return
            }
            setRoles( res.roles )
        })
    }

    const editRole = ( uid ) => {
        editRoleUid.current = uid 
        setShowEditRole(true)
    }

    return (
        <>
            <Helmet>
                <title> Clinic Manager | Roles </title>
            </Helmet>

            <Container style={{ height:'calc(100vh - 60px)', maxWidth:'1000px', overflowY:'scroll'}}>

            <div style={{ width:'100%' }}>
                <div className="d-flex justify-content-center align-items-center" 
                     style={{ padding:'10px', width:'100%' }}>
                    <Button onClick={ openAddRoleModal } size="sm">Add Role</Button>
                </div>
            </div>

            <div style={{ height:'calc(100% - 60px)', width:'100%', overflowY:'auto' }}>
                <Table striped hover>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Unique ID</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    { roles && 
                    <tbody>
                        { roles.map( (role,idx) => 
                        <RoleRow key={idx} info={role} index={idx} editFn={editRole} removeFn={removeRole}/>
                        )}
                    </tbody>
                    }
                </Table>
            </div>


            <AddRoleModal showModal={showAddRole}
                          setShowModal={setShowAddRole}
                          setRoles={setRoles}
                          departments={departments}
            />

            <EditRoleModal showModal={showEditRole}
                           setShowModal={setShowEditRole}
                           roleUid={editRoleUid} 
                           roles={roles}
                           setRoles={setRoles} 
                           departments={departments}
            />
            </Container>
        </>
    )
}
